<template>
  <div>
    <v-menu v-model="menu_ativo" :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-btn small icon v-on="on" v-bind="attrs">
          <v-icon :size="18">$Cog</v-icon>
        </v-btn>
      </template>

      <div class="bg-white pa-2 pb-1">
        <p class="mb-2 font-14 font-weight-medium">
          <v-icon :size="18">$Cog</v-icon>
          Configuração
        </p>

        <v-divider class="py-1" />

        <v-select
          label="Quantidade de Meses de Exibição"
          v-model="qtde_meses_selecionado"
          :items="itens_qtde_meses"
          hide-details
          item-value="id"
          item-text="tipo_visao"
          outlined
          dense
          class="mt-1"
          @change="salvarPreferenciaChartUsuario()"
        />

        <div class="d-flex align-center mt-2">
          <v-spacer />

          <v-btn small text @click="menu_ativo = false">
            fechar
          </v-btn>
        </div>
      </div>
    </v-menu>
  </div>
</template>

<script setup>
import api from "@/api/api";
import {logout} from "@/helpers";
import { onMounted, ref, watch } from "vue";

const props = defineProps({
  qtde_meses_pai: {
    type: Number,
    required: false,
    default: 0
  }
});

const emit = defineEmits(['update:qtde-meses']);

const itens_qtde_meses = [
  { id: 12, tipo_visao: "12 meses" },
  { id: 24, tipo_visao: "24 meses" },
];

const menu_ativo = ref(false);
const qtde_meses_selecionado = ref(12);

const id_usuario_logado = localStorage.getItem('id');
const id_tabela_preferencia = 'DETALHES_PRODUTO_GRAFICO_MOVIMENTACOES_QTD_MESES_EXIBICAO';

onMounted(buscarPreferenciaChartUsuario);

watch(() => props.qtde_meses_pai, (newVal) => {
  qtde_meses_selecionado.value = newVal;
  salvarPreferenciaChartUsuario();
});

function buscarPreferenciaChartUsuario() {
  const url = `/preferencias/usuarios/${id_usuario_logado}/tabelas/${id_tabela_preferencia}`;
  api.get(url)
    .then(response => {
      if (response.data.preferencia) {
        const preferencia = JSON.parse(response.data.preferencia.preferencias);
        qtde_meses_selecionado.value = preferencia.qtde_meses;
      }

      emitirEventoAtualizacao(qtde_meses_selecionado.value);
    })
    .catch(logout);
}

function salvarPreferenciaChartUsuario() {
  const url = `/preferencias/usuarios/${id_usuario_logado}/tabelas/${id_tabela_preferencia}`;

  api.post(url, { qtde_meses: qtde_meses_selecionado.value })
    .then(() => {
      emitirEventoAtualizacao(qtde_meses_selecionado.value);
    })
    .catch(logout);
}

function emitirEventoAtualizacao(qtde_meses) {
  emit("update:qtde-meses", { qtde_meses });
}
</script>

<style scoped>

</style>
